var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationgold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_2590_44743)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 5.5C12.2292 5.50209 10.5317 6.20639 9.27971 7.45842C8.02769 8.71044 7.32339 10.4079 7.3213 12.1786C7.31918 13.6255 7.79182 15.0332 8.66672 16.1857C8.66672 16.1857 8.84887 16.4255 8.87862 16.4601L13.9999 22.5L19.1235 16.4571C19.1503 16.4249 19.333 16.1857 19.333 16.1857L19.3336 16.1839C20.2081 15.0319 20.6805 13.6249 20.6784 12.1786C20.6764 10.4079 19.972 8.71044 18.72 7.45842C17.468 6.20639 15.7705 5.50209 13.9999 5.5ZM13.9999 14.6071C13.5195 14.6071 13.05 14.4647 12.6506 14.1979C12.2512 13.931 11.94 13.5517 11.7562 13.1079C11.5723 12.6642 11.5243 12.1759 11.618 11.7048C11.7117 11.2337 11.943 10.801 12.2826 10.4613C12.6223 10.1217 13.055 9.89037 13.5261 9.79666C13.9972 9.70296 14.4855 9.75105 14.9292 9.93486C15.373 10.1187 15.7523 10.43 16.0192 10.8293C16.286 11.2287 16.4284 11.6982 16.4284 12.1786C16.4276 12.8224 16.1715 13.4397 15.7162 13.8949C15.261 14.3502 14.6437 14.6063 13.9999 14.6071Z",
    fill: "#2B2B2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2590_44743",
    x1: 14,
    y1: -5.04,
    x2: 14,
    y2: 32.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationgold);
export default __webpack_public_path__ + "static/media/locationgold.69536adf9bad9f195026ffebb271f1f4.svg";
export { ForwardRef as ReactComponent };